import { CustomerDocument } from '@graphcommerce/magento-customer'
import { useCustomerQuery } from '@graphcommerce/magento-customer/hooks'
import { useRouter } from 'next/router'
import { useCallback, useEffect } from 'react'
import { ChatSignInForm } from './ChatSignInForm'

export function SignupOrCheckout() {
  const router = useRouter()
  const { data } = useCustomerQuery(CustomerDocument)
  const isLoggedIn = Boolean(data?.customer?.email)

  const goToCheckout = useCallback(() => router.push('/checkout'), [router])

  useEffect(() => {
    if (isLoggedIn) goToCheckout()
  }, [isLoggedIn, goToCheckout])

  if (isLoggedIn) {
    return (
      <div className='my-3 flex flex-col items-center gap-3 overflow-hidden rounded-[22px] bg-white/80 px-5 py-6 shadow-[0_4px_24px_rgba(0,0,0,0.08),0_0_0_0.5px_rgba(0,0,0,0.05),inset_0_1px_0_rgba(255,255,255,1)] backdrop-blur-2xl'>
        <p className='text-[15px] text-[#6C6C70]'>
          You&apos;re signed in! Taking you to checkout…
        </p>
        <button
          type='button'
          onClick={goToCheckout}
          className='w-full rounded-[14px] bg-[rgba(0,0,0,0.07)] py-3.5 text-[17px] font-semibold text-black transition-all active:scale-[0.98]'
        >
          Go to Checkout
        </button>
      </div>
    )
  }

  return <ChatSignInForm onClose={() => {}} />
}
